import { useContext, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { SidebarContext } from 'src/contexts/SidebarContext';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import ArticleIcon from '@mui/icons-material/Article';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AccessTime } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Logo from 'src/components/Logo';

import { Box, Drawer, Hidden, List } from '@mui/material';

import { styled } from '@mui/material/styles';
import SidebarMenu from './SidebarMenu';
import { useLocation, useNavigate } from 'react-router';
import { CollapseContext } from 'src/contexts/CollapseContext';
import { useTransition, animated, useSpring } from 'react-spring';
import CollapsedSidebar from './SidebarMenu/CollapsedSidebar/CollapsedSidebar';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        color: #031349;
        background: #E6E9FF;
        box-shadow: ${theme.sidebar.boxShadow};
        height: 100%;
        
        @media (min-width: 1024px) {
            position: fixed;
            z-index: 10;
            border-top-right-radius: ${theme.general.borderRadius};
            border-bottom-right-radius: ${theme.general.borderRadius};
        }
`
);

const TopSection = styled(Box)(
  ({ theme }) => `
        display: flex;
        height: 60px;
        justify-content: center;
        align-items: center;
`
);

const Sidebar = () => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { collapseToggle, toggleCollapse } = useContext(CollapseContext);

  const transitions = useTransition(collapseToggle, {
    key: collapseToggle,
    initial: { opacity: 1 },
    from: { opacity: 0, position: 'absolute' as const },
    leave: { opacity: 0, position: 'relative' as const },
    enter: { opacity: 1, position: 'relative' as const },
    config: { mass: 50, tension: 2000, friction: 250, duration: 250 }
  });

  const contentProps = useSpring({
    opacity: collapseToggle ? 1 : 0,
    marginLeft: collapseToggle ? 0 : -100,
    config: { mass: 5, tension: 1500, friction: 200 }
  });

  const contentPropsRight = useSpring({
    opacity: !collapseToggle ? 1 : 0,
    marginLeft: !collapseToggle ? 0 : -100,
    config: { mass: 5, tension: 1500, friction: 200 }
  });

  const [isClickedMenuItem, setIsClickedMenuItem] = useState<boolean>(false);

  const menuItemHandler = (value) => {
    setIsClickedMenuItem(value);
  };

  return (
    <>
      <animated.div style={contentProps}>
        <SidebarWrapper style={{ display: `${!collapseToggle ? 'none' : ''}` }}>
          <Scrollbars autoHide>
            <TopSection>
              <Logo />
            </TopSection>
            <SidebarMenu menuItemHandler={menuItemHandler} />
          </Scrollbars>
        </SidebarWrapper>
      </animated.div>

      <animated.div style={contentPropsRight}>
        <CollapsedSidebar />
      </animated.div>
    </>
  );
};

export default Sidebar;
